import React, { forwardRef, useState } from "react";
import {
  CreditCardUnifiedProps,
  RefsCardsUnified,
  unifiedErrorAttr,
} from "./types/credit-card-unified.types";
import { CardNumber } from "./credit-card-fields-components/card-number";
import { CvvField } from "./credit-card-fields-components/cvv";
import { ExpirationDateField } from "./credit-card-fields-components/expiration-date";
import classNames from "classnames";

export interface CreditCardUnifiedWithForwardRef
  extends React.ForwardRefExoticComponent<
    CreditCardUnifiedProps & React.RefAttributes<() => RefsCardsUnified>
  > {}

export const CreditCardUnified = forwardRef<
  () => RefsCardsUnified,
  CreditCardUnifiedProps
>(
  (
    {
      creditCard,
      expirationDate,
      cvvField,
      unifiedFieldsStatusMessage,
      unifiedStatus,
    }: CreditCardUnifiedProps,
    ref
  ): React.ReactElement => {
    const [cvvLength, setCvvLength] = useState<number>(3);
    const [focus, setFocus] = useState(false);
    const attr: unifiedErrorAttr = {};
    const { cardNumberRef, expirationDateFieldRef, cvvFieldRef } =
      (ref as any)?.() || {};

    if (unifiedStatus) {
      // @ts-ignore
      attr[`data-${unifiedStatus}`] = true;
    }

    const wrapperClasses = classNames("spark-payment--unified", {
      active: focus,
    });

    return (
      <div
        className={wrapperClasses}
        {...attr}
        onFocus={(e): void => {
          const { classList } = e.target;
          if (
            classList.contains("spark-btn--icon") ||
            classList.contains("spark-popover__close")
          ) {
            return;
          }
          setFocus(true);
        }}
        onBlur={(e): void => setFocus(false)}
      >
        <CardNumber
          {...creditCard}
          setCvvLength={setCvvLength}
          ref={cardNumberRef}
          hideError={true}
        />
        <div className="spark-payment--unified__fields">
          <ExpirationDateField
            {...expirationDate}
            unifiedFields={true}
            ref={expirationDateFieldRef}
          />
          <CvvField
            {...cvvField}
            cvvLength={cvvLength}
            unifiedFields={true}
            ref={cvvFieldRef}
          />
        </div>
        <span className="spark-input__message">
          {unifiedFieldsStatusMessage}
        </span>
      </div>
    );
  }
) as CreditCardUnifiedWithForwardRef;

CreditCardUnified.displayName = "CreditCardUnified";
